import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectCountry, selectPayment, selectShowInvalids } from '@store/order/selectors';
import { setPayment } from '@store/order/slice';
import Checkbox from '@components/checkbox/Checkbox';
import { invalidFormValue } from '@components/utils';
import { useLazyGetPaymentTypesQuery } from '@api/baseApi';
import { PaymentTypeDef } from '@api/types/PaymentTypeDef';
import { getFormattedPrice } from '@translations/functions';



const Payment = () => {
	const { t } = useTranslation('forms');

	const country = useSelector(selectCountry);
	const payment = useSelector(selectPayment);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updatePayment = (value: PaymentTypeDef | null) => dispatch(setPayment(value));

	const [ getPayments, { data, isLoading, isFetching, isError, isSuccess } ] = useLazyGetPaymentTypesQuery();

	useEffect(() => {
		if (country) {
			getPayments({ country }, true);
		}
	}, [ country ]);

	return (
		<div className='payment-section'>

			<label className='payment-label'>
				{t('paymentShipping.payment.sectionLabel') + ' '}<span>*</span> {showInvalids && invalidFormValue(payment) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			{isError &&
				<p className='error-message'>{t('paymentShipping.errorMessage')}</p>}

			{(isLoading || isFetching) &&
				<p className='loading-message'>{t('paymentShipping.loadingMessage')}</p>}

			{isSuccess && data && data.length === 0 &&
				<p className='info-message'>{t('paymentShipping.payment.emptyMessage')}</p>}

			{isSuccess && data && data.length > 0 && data.map(x =>
				<Checkbox isSelected={payment ? payment.id === x.id : false} onChange={() => updatePayment(x)} isRequired={true} key={`order-form-payment-${x.id}`}>
					{`${x.description} (${
						x.price === 0 ? t('units.free') : getFormattedPrice(country, x.price)
					})`}
				</Checkbox>)}

		</div>
	);
};

export default Payment;